module.exports = __webpack_public_path__ + "static/squares-pictures-2-27223d97f3253aea6c76485185ece1f8.png";